import axios from "axios"

export default ({
  query = null,
  variables = null,
  url = "https://api.covergo.com/graphql",
  method = "POST",
  headers = null,
}) => {
  return new Promise((resolve, reject) => {
    axios({
      baseURL: url,
      method,
      data: {
        query,
        variables
      },
      headers: {
        ...headers,
        "Content-type": "application/json",
      },
    })
      .then(res => {
        console.group("--------------- API RESPONSE ---------------")
        console.dir(res.data)
        console.groupEnd()
        const data = res.data
        resolve(data)
      })
      .catch(error => {
        console.error("GQL: There was an error in response", error)
        reject(error)
      })
  })
}


// WEBPACK FOOTER //
// ./src/lib/api.js